import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EntityName } from '@shared/enums/entity-name.enum';
import { Category } from '@shared/interfaces/category.interface';
import { TranslateServiceLanguage } from '@shared/interfaces/language.interface';
import { OrganizationInterface } from '@shared/interfaces/organization.interface';
import { StartPageSettings } from '@shared/interfaces/start-page.interface';
import { TenantInterface } from '@shared/interfaces/tenant.interface';
import { StringUtils } from '@shared/utils/string-utils';
import { Observable } from 'rxjs';
import { BaseHttpService } from './base-http.service';

@Injectable({
  providedIn: 'root',
})
export class TenantHttpService extends BaseHttpService<TenantInterface> {
  apiUrl = 'tenants';

  constructor(protected http: HttpClient) {
    super(http);
  }

  // Get current id by domain
  getCurrentTenantId(domain: string): Observable<TenantInterface> {
    const currentDomain = domain;
    const jipLocale =
      StringUtils.getLocaleFromUrl() || TranslateServiceLanguage.de; // For elementor page

    const headers = new HttpHeaders({ 'jip-locale': jipLocale });

    return this.http.get<TenantInterface>(
      `${this.apiUrl}/domain?domain=${currentDomain}`,
      { headers }
    );
  }

  getTenantCommunitySpaces(): Observable<OrganizationInterface[]> {
    const url = `${this.apiUrl}/featured-innovation-space`;

    return this.http.get<OrganizationInterface[]>(url);
  }

  updateTenantCommunitySpaces(payload): Observable<void> {
    const url = `${this.apiUrl}/featured-innovation-space`;

    return this.http.post<void>(url, payload);
  }

  getTenantCategories(
    id: number,
    entityName?: EntityName
  ): Observable<Category[]> {
    const url = `${this.apiUrl}/${id}/categories`;
    const params = entityName ? { entityName } : {};

    return this.http.get<Category[]>(url, {
      params,
    });
  }

  getSecretKey(tenantId: number): Observable<string> {
    const url = `${this.apiUrl}/${tenantId}/generate-secret`;

    return this.http.get<string>(url);
  }

  removeWebhook(tenantId: number, webhookId: number): Observable<void> {
    const url = `${this.apiUrl}/${tenantId}/webhooks/${webhookId}`;

    return this.http.delete<void>(url);
  }

  getWebhookSample(tenantId: number): Observable<string> {
    const url = `${this.apiUrl}/${tenantId}/webhook-sample`;

    return this.http.get<string>(url);
  }

  saveStartPage(
    tenantId: number,
    payload: Record<string, StartPageSettings>
  ): Observable<void> {
    const url = `${this.apiUrl}/${tenantId}/start-page`;

    return this.http.put<void>(url, payload);
  }
}
